var map = {
	"./Article": 2064,
	"./Article/": 2064,
	"./Article/index": 2064,
	"./Article/index.jsx": 2064,
	"./Article/styles.module.css": 50574,
	"./ContactLayout": 73676,
	"./ContactLayout/": 73676,
	"./ContactLayout/SimpleCheckbox": 10903,
	"./ContactLayout/SimpleCheckbox/": 10903,
	"./ContactLayout/SimpleCheckbox/index": 10903,
	"./ContactLayout/SimpleCheckbox/index.jsx": 10903,
	"./ContactLayout/SimpleCheckbox/styles.module.css": 79498,
	"./ContactLayout/SimpleRadioButton": 59473,
	"./ContactLayout/SimpleRadioButton/": 59473,
	"./ContactLayout/SimpleRadioButton/index": 59473,
	"./ContactLayout/SimpleRadioButton/index.jsx": 59473,
	"./ContactLayout/SimpleRadioButton/styles.module.css": 45046,
	"./ContactLayout/index": 73676,
	"./ContactLayout/index.jsx": 73676,
	"./ContactLayout/styles.module.css": 13025,
	"./FooterLayout": 93444,
	"./FooterLayout/": 93444,
	"./FooterLayout/index": 93444,
	"./FooterLayout/index.jsx": 93444,
	"./FooterLayout/styles.module.css": 42113,
	"./GalleryLayout": 96069,
	"./GalleryLayout/": 96069,
	"./GalleryLayout/index": 96069,
	"./GalleryLayout/index.jsx": 96069,
	"./GalleryLayout/styles.module.css": 34853,
	"./HeroLayout": 34142,
	"./HeroLayout/": 34142,
	"./HeroLayout/index": 34142,
	"./HeroLayout/index.jsx": 34142,
	"./HeroLayout/styles.module.css": 42803,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;